export const SAVE_SLOTS = 'consulting/calendar/saveSlots'
export const CALENDAR_SLOTS = 'fo/calendar/slots'
export const CALENDAR_SLOT = 'consulting/calendar/editSlot'
export const BLOCK_SLOT = 'consulting/calendar/blockSlot'
export const FREE_SLOT = 'consulting/calendar/freeSlot'
export const SET_REFERENCE_DATE = 'consulting/calendar/setReferenceDate'
export const RESET_REFERENCE_DATE = 'consulting/calendar/resetReferenceDate'
export const DELETE_SLOT = 'fo/calendar/deleteSlot'
